import CancelPolicy from "../../organisms/ManagePolicy/CancelPolicy";
import Modal from "../../../components/molecules/Modal";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { Cache } from "aws-amplify";
import {
  manageAPI,
  authAPI,
  authDetails,
  renewalAPI,
} from "../../../api/fetch-api";
import { Loading } from "../../atoms/loading";

export default function Services(props) {
  let history = useHistory();

  const [polStatus, setPolStatus] = useState("A");
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openPS, setOpenPS] = useState(false);
  const [carAgeWithin15Years, setCarAgeWithin15years] = useState(true);

  useEffect(() => {
    const customerID = Cache.getItem("customerId").replaceAll(" ", "%2B");
    if (props.productType === "SITRVL01" || props.productType === "SITRVL02") {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
      //CANCEL STATUS CHECKER
      //if (travelDetails === "C") {
      setPolStatus("");
      //}
    } else if (props.productType === "SIPETI01") {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
      //CANCEL STATUS CHECKER
      //if (travelDetails === "C") {
      setPolStatus("");
      //}
    } else {
      authAPI
        .getAuth(authDetails)
        .then((data1) => {
          Cache.setItem("ginsure_token", data1.token);
          manageAPI
            .getPolicy(Cache.getItem("unid"), customerID, data1.token)
            .then((data) => {
              setTimeout(() => {
                setIsLoading(false);
              }, 500);
              //CANCEL STATUS CHECKER
              setPolStatus(data.status);

              setIsLoading(false);

              // if (data.status === "C") {
              //   setPolStatus(data.status);
              // }
              // else{
              //   setPolStatus(data.status);
              // }
            })
            .catch((error) => {
              console.log(error);
              console.log("There was an error!");
            });
        })
        .catch((error) => {
          console.log(error);
          console.log("There was an error!");
        });
    }
  }, []);

  const gotoRenewPolicy = () => {
    setIsLoading(true);
    Cache.setItem("renewalData", null);
    renewalAPI
      .postRenewalNotice(Cache.getItem("unid"))
      .then((data) => {
        Cache.setItem("renewalData", data);
        setIsLoading(false);
        setTimeout(() => {
          const prodcode = data.policyNumber?.split("-")[1];


          const isPYPOrPYVOrPYB = prodcode === "PYP" || prodcode === "PYV" || prodcode === "PYB";

          if (isPYPOrPYVOrPYB) {

            if (data.nonRenewableFlag) {
              setOpen(true);
            } else {
              if (data.carAgeWithin15Years) {
                history.push("/renewal/motor/");
              } else {
                setCarAgeWithin15years(data.carAgeWithin15Years);
              }
            }
          } else {

            if (
              data.powerSource === "PHEV" ||
              data.powerSource === "HYBRID" ||
              data.powerSource === "MILD HYBRID"
            ) {
              setOpenPS(true);
              return;
            }

            // Continue with normal renewal flow for other prodcodes
            if (data.nonRenewableFlag) {
              setOpen(true);
            } else {
              if (data.carAgeWithin15Years) {
                history.push("/renewal/motor/");
              } else {
                setCarAgeWithin15years(data.carAgeWithin15Years);
              }
            }
          }
        }, 500);
      })
      .catch((error) => {
        console.log(error);
        console.log("There was an error!");
        alert("There was an API error!");
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      });
  };

  const gotoCancelPolicy = () => {
    Cache.setItem("productType", props.productType);
    history.push("/manage-policy/" + Cache.getItem("unid") + "/cancel-request");
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      <div className="mt-5">
        {/* <div className="border-b-2 border-gray-200 py-5 px-8">
          <div className="grid grid-cols-2">
            <div>
              <img
                src={"/images/file-icon.png"}
                alt="file"
                className="manage-icon"
              />
              <span>File A Claim</span>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 float-right"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div> */}

        <>
          {polStatus !== "C" && polStatus !== "R" && polStatus !== "F" && (
            <div
              className="border-b-2 border-gray-200 py-5 px-8"
              onClick={gotoCancelPolicy}
            >
              <div className="grid grid-cols-3">
                <div className="col-span-2">
                  <button>
                    <img
                      src={"/images/cancel-icon.png"}
                      alt="cancel"
                      className="manage-icon"
                    />
                    <span className="manage-policy-font">
                      Request Cancel Policy
                    </span>
                  </button>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 float-right"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          )}

          {(props.productType === "SITRVL01" ||
            props.productType === "SITRVL02") && (
              <div className="py-5 px-8">
                <p className="text-xs manage-policy-font">
                  Please take note of the following if you wish to cancel your
                  policy.
                </p>
                <br />
                <p className="text-xs manage-policy-font mb-5">
                  1. If the policy cancellation is within the day before 11:00 PM,
                  the full premium refund will be automatically credited to your
                  GCash wallet.
                </p>
                <p className="text-xs manage-policy-font">
                  2. If the policy cancellation is beyond 11:00 PM, our
                  representative will manually process your refund.
                </p>
              </div>
            )}

          {polStatus === "F" &&
            ((carAgeWithin15Years && props.productType !== "SIVEIN03") ? (
              <div
                className="border-b-2 border-gray-200 py-5 px-8"
                onClick={gotoRenewPolicy}
              >
                <div className="grid grid-cols-3">
                  <div className="col-span-2">
                    <button>
                      <img
                        src={"/images/cancel-icon.png"}
                        alt="cancel"
                        className="manage-icon"
                      />
                      <span className="manage-policy-font">Renew Policy</span>
                    </button>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 float-right"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            ) : (
              <div className="p-5 m-5 border rounded-lg">
                <p className="mb-2">
                  This policy is non-renewable, due to age of your vehicle.
                </p>
                <p className="mb-2">
                  For questions or clarification, please call (0917) 828-3984 or
                  send us an email at ginsure@standard-insurance.com.
                </p>
                <p className="mb-2">Thank you.</p>
              </div>
            ))}

          <Modal open={open} setOpen={setOpen} title="">
            <div className="flex"></div>
            <p className="my-5">
              Your policy is non-renewable. Kindly wait for our email or a
              representative to contact you for an update regarding your policy.
              <br />
              <br />
              You may call us at (0917) 828-3984 or send an email to
              ginsure@standard-insurance.com
              <br />
              <br />
              Thank you.
            </p>
          </Modal>

          <Modal open={openPS} setOpen={setOpenPS} title="">
            <div className="flex"></div>
            <p className="my-5">
              Your policy is being updated following a change in your vehicle's tagging.
              <br />
              <br />
              For questions or clarification, please call (0917) 828-3984 or send an email to
              ginsure@standard-insurance.com
              <br />
              <br />
              Thank you.
            </p>
          </Modal>
        </>
      </div>
    </>
  );
}
